import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('⚠️ ErrorBoundary caught:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex flex-col items-center justify-center bg-stone-50 px-6 text-center">
                    <div className="w-14 h-14 rounded-2xl bg-stone-100 flex items-center justify-center mb-4">
                        <span className="text-2xl">😵</span>
                    </div>
                    <h2 className="text-lg font-semibold text-stone-800 mb-1">Something went wrong</h2>
                    <p className="text-sm text-stone-500 mb-6 max-w-xs">
                        An unexpected error occurred. Tap below to reload.
                    </p>
                    <button
                        onClick={() => {
                            this.setState({ hasError: false, error: null });
                            window.location.reload();
                        }}
                        className="px-6 py-2.5 bg-stone-800 text-white text-sm font-medium rounded-full shadow-lg hover:bg-stone-700 transition-colors"
                    >
                        Reload App
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
